import classNames from "classnames";
import React from "react";
import { ENGLISH } from "../../../../public/Constants/EnumConstants";
import {
    STYLIST_CARD_TITLE_CLASS,
    TEXT_LEFT_ALIGNMENT_ON_HOVER,
    TEXT_RIGHT_ALIGNMENT_ON_HOVER,
} from "./constants";

const StylistCardTitle = ({ text, alignment }) => {
    const textClass = classNames(
        STYLIST_CARD_TITLE_CLASS,
        alignment === ENGLISH
            ? TEXT_LEFT_ALIGNMENT_ON_HOVER
            : TEXT_RIGHT_ALIGNMENT_ON_HOVER
    );
    return <p className={textClass}>{text}</p>;
};

export default StylistCardTitle;
